export default __webpack_public_path__ + "static/media/Armani.6c2d6c47.jpg";